import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .directive('vatCollectabilitySelector', function () {
    return {
      restrict: 'A',
      scope: {
        optional: '=?',
        optionalText: "@",
      },
      template: '<option ng-if="optional" value="">{{ (!!optionalText) ? optionalText : "Nessuno" }}</option><option value="{{ item.id }}" ng-repeat="item in items">{{ item.name }}</option>',
      replace: false,
      controller: ['$scope', function ($scope) {
        $scope.items = [
          { id: 'IMMEDIATE', name: 'Immediata' },
          { id: 'DEFERRED', name: 'Differita' },
          { id: 'SPLIT_PAYMENT', name: 'Scissione dei pagamenti' },
        ];
      }],
    };
  });
